import TYPES from '../../types';

// Domain
import { BusinessActivityEntity } from '../../domain/entities/business-activity-entity';
import { BusinessActivityRepository } from '../../domain/repository/business-activity-repository';
import { StateManager } from '../../domain/state/state-manager';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import Query from '@/modules/shared/domain/use-cases/query';

@Injectable()
export default class SearchBusinessActivitiesQuery extends
  Query<Promise<Array<BusinessActivityEntity>>> {
  @Inject(TYPES.CATALOG_KUSPIT_BUSINESS_ACTIVITY_STATE_MANAGER)
  private readonly state_manager!: StateManager;

  @Inject(TYPES.CATALOG_KUSPIT_BUSINESS_ACTIVITY_REPOSITORY)
  private readonly repository!: BusinessActivityRepository;

  internalExecute(): Promise<Array<BusinessActivityEntity>> {
    return new Promise((resolve, reject) => {
      if (!this.state_manager.state.loaded) {
        this.repository.execute()
          .then((items) => {
            this.state_manager.patch({ items, loaded: true });
            resolve(items);
          })
          .catch(reject);
      } else {
        resolve(this.state_manager.state.items);
      }
    });
  }
}
